export const PENDING_TRUST_DEVICE_KEY = 'pending_trust_device';

const UNKNOWN_BROWSER_LABEL = 'Unknown browser';
const UNKNOWN_OS_LABEL = 'Unknown OS';

/** @returns {string} */
export function deriveDeviceLabel() {
  const userAgent = navigator.userAgent;

  const browserPatterns = [
    { name: 'Edge', pattern: /Edg\// },
    { name: 'Chrome', pattern: /Chrome\/[\d.]+ (?!.*Chromium)/ },
    { name: 'Firefox', pattern: /Firefox\// },
    { name: 'Safari', pattern: /Safari\// },
  ];

  const osPatterns = [
    { name: 'Windows', pattern: /Windows/ },
    { name: 'iOS', pattern: /iPhone|iPad/ },
    { name: 'macOS', pattern: /Macintosh|Mac OS X/ },
    { name: 'Android', pattern: /Android/ },
    { name: 'Linux', pattern: /Linux/ },
  ];

  const browser = browserPatterns.find(({ pattern }) => pattern.test(userAgent))?.name ?? UNKNOWN_BROWSER_LABEL;
  const os = osPatterns.find(({ pattern }) => pattern.test(userAgent))?.name ?? UNKNOWN_OS_LABEL;

  return `${browser} on ${os}`;
}
